


















































































































































































import { computed, defineComponent, onMounted, reactive, toRefs, ref, getCurrentInstance } from '@vue/composition-api';
import {
  CloseCircleFilledIcon,
  SearchIcon,
  DeleteIcon,
  HistoryIcon,
  MinusCircleIcon,
  SettingIcon,
  InfoCircleFilledIcon,
} from 'tdesign-icons-vue';
import { DialogInstance, DialogPlugin } from 'tdesign-vue';

// 引入组件
import InviteExtMembers from '@/renderer/views/desktop/ManageConsole/UserManagement/externalUser/components/InviteExtDialog.vue';
import ImportExtUserDialog from '@/renderer/views/desktop/ManageConsole/UserManagement/externalUser/components/importExtUserDialog.vue';

// 引入 compositions
import listHandler from '@/renderer/views/desktop/ManageConsole/UserManagement/externalUser/compositions/listHandler';
import listOperateHandler from '@/renderer/scripts/composition/listOperateHandler';
import userActionHandler from '@/renderer/views/desktop/ManageConsole/UserManagement/externalUser/compositions/userActionHandler';
import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';

// 引入工具类
import i18n, { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';
import store from '@/renderer/store';
import { ExtUserListItemData } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import { phoneCompose, getNameTipsDetail } from '@/renderer/scripts/utils/tools/index';
import { IS_PRIVATE } from '@/common/constant/platform';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';

export default defineComponent({
  name: 'extUser',
  components: {
    InviteExtMembers,
    CloseCircleFilledIcon,
    SearchIcon,
    ImportExtUserDialog,
    DeleteIcon,
    HistoryIcon,
    MinusCircleIcon,
    SettingIcon,
    InfoCircleFilledIcon,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    // 外部账号列表数据
    const { keyword, columns, loading, tableData, pageData, sort, searchStatus, methods: listMethods } = listHandler();
    // 列表操作
    const {
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      hoverIndex,
      methods: listOperateMethods,
    } = listOperateHandler(tableData);
    // 外部账号user相关
    const { itemData, methods: userMethods } = userActionHandler();

    const resizeColumns = ref(setResizableColumns(columns));

    const enableGoLive = computed(() => {
      const newList = tableData.selectedList.filter(value => {
        return !value.enabled;
      });
      return newList.length > 0;
    });
    const enableForbidden = computed(() => {
      const newList = tableData.selectedList.filter(value => {
        return value.enabled;
      });
      return newList.length > 0;
    });
    // 记录弹窗的显示和隐藏
    const showDialog = reactive<Record<string, boolean>>({
      importExt: false,
      inviteUser: false,
    });
    const methods = {
      toggleDialog(key: string, value: boolean) {
        showDialog[key] = value;
      },
      // 打开手机号邀请弹框
      async openExtImport() {
        const canAddUser = await store.dispatch('checkUserCount');
        if (!canAddUser) return;
        itemData.nickname = '';
        itemData.phoneNumber = '';
        itemData.comment = '';
        itemData.countryCode = '+86';
        itemData.allowSms = true;
        methods.toggleDialog('importExt', true);
      },
      // 打开链接邀请弹框
      async openInviteDialog() {
        // 查询当前用户总数
        const canAddUser = await store.dispatch('checkUserCount');
        if (!canAddUser) return;
        methods.toggleDialog('inviteUser', true);
      },
      // 删除外部账号
      deleteItem(row: ExtUserListItemData) {
        this.deleteUsersFn(row);
      },
      // 管理外部账号
      settingItem(row: ExtUserListItemData) {
        itemData.userId = row.id;
        itemData.nickname = row.nickname;
        itemData.phoneNumber = row.phoneNumber;
        itemData.comment = row.comment;
        itemData.countryCode = row.countryCode;
        // itemData.allowSms = row.allowSms;
        methods.toggleDialog('importExt', true);
      },
      // 设置外部账号状态：冻结；启用
      setStateItem(row: ExtUserListItemData) {
        this.setEnabled(!row.enabled, row);
      },
      // 批量启用外部账号
      multipleGoLive() {
        this.setEnabled(true, null);
      },
      // 批量冻结外部账号
      multipleForbidden() {
        this.setEnabled(false, null);
      },
      // 批量删除外部账号
      multipleDelete() {
        this.deleteUsersFn();
      },
      // 设置冻结 启用
      async setEnabled(enabled: boolean, row: ExtUserListItemData | null) {
        const list = row ? [row] : tableData.selectedList;
        const tip = row
          ? i18n_t('确定要{slot1}{slot2}吗？', {
              slot1: enabled ? i18n_t('启用') : i18n_t('冻结'),
              slot2: row.nickname,
            })
          : i18n_t('确定要{slot1}所选的{slot2}个用户吗？', {
              slot1: enabled ? i18n_t('启用') : i18n_t('冻结'),
              slot2: list.length,
            });
        const dialog: DialogInstance = CustomDialog.confirm({
          theme: 'warning',
          header: tip,
          body: `${enabled ? i18n_t('启用后，账号将恢复使用') : i18n_t('冻结后，账号将无法登录')}`,
          async onConfirm() {
            if (dialog.hide) {
              dialog.hide();
            }
            const isSuccessful = await userMethods.optUser(!enabled, list);
            if (isSuccessful) {
              await listMethods.pullUserList();
            }
          },
        });
      },
      // 批量删除
      async deleteUsersFn(row?: ExtUserListItemData) {
        const list = row ? [row] : tableData.selectedList;
        const tip = row
          ? i18n_t('确认要删除{slot1}吗？', {
              slot1: row.nickname,
            })
          : i18n_t('确认要删除选中的{slot1}个临时用户吗？', {
              slot1: list.length,
            });
        const dialog: DialogInstance = CustomDialog.confirm({
          theme: 'warning',
          header: tip,
          body: h => {
            const baseTip = h('p', i18n_t('删除后，用户数据不可被找回。'));
            return h('div', [baseTip]);
          },
          confirmBtn: {
            content: i18n_t('删除'),
            theme: 'danger',
          },
          cancelBtn: i18n_t('取消'),
          // 删除
          async onConfirm() {
            if (dialog.hide) {
              dialog.hide();
            }
            const isSuccessful = await userMethods.deleteUser(list);
            if (isSuccessful) {
              await listMethods.pullUserList();
            }
          },
          // 取消
          async onCancel() {
            if (dialog.hide) {
              dialog.hide();
            }
          },
        });
      },
    };
    onMounted(() => {
      listMethods.pullUserList();
    });
    return {
      IS_PRIVATE,
      keyword,
      ...methods,
      listMethods,
      showDialog,
      resizeColumns,
      loading,
      sort,
      itemData,
      ...toRefs(tableData),
      ...toRefs(pageData),
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      hoverIndex,
      listOperateMethods,
      enableGoLive,
      enableForbidden,
      phoneCompose,
      getNameTipsDetail,
      searchStatus,
    };
  },
});
